module.exports = __webpack_public_path__ + "static/media/ladyArms.7ead8039.svg";